// prettier-ignore
export let ABI = [
    {
      'inputs': [
        {
          'internalType': 'address',
          'name': '_storage',
          'type': 'address'
        },
        {
          'internalType': 'address',
          'name': '_master',
          'type': 'address'
        },
        {
          'internalType': 'bytes32',
          'name': '_key',
          'type': 'bytes32'
        },
        {
          'internalType': 'address',
          'name': '_relayHub',
          'type': 'address'
        }
      ],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'constructor'
    },
    {
      'anonymous': false,
      'inputs': [
        {
          'indexed': true,
          'internalType': 'address',
          'name': 'previousDeveloper',
          'type': 'address'
        },
        {
          'indexed': true,
          'internalType': 'address',
          'name': 'newDeveloper',
          'type': 'address'
        }
      ],
      'name': 'DeveloperTransferredEvent',
      'type': 'event'
    },
    {
      'anonymous': false,
      'inputs': [
        {
          'indexed': false,
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        },
        {
          'indexed': false,
          'internalType': 'address',
          'name': 'who',
          'type': 'address'
        },
        {
          'indexed': false,
          'internalType': 'uint256',
          'name': 'status',
          'type': 'uint256'
        },
        {
          'indexed': false,
          'internalType': 'string',
          'name': 'eventText',
          'type': 'string'
        }
      ],
      'name': 'OwnerEvent',
      'type': 'event'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'contractName',
      'outputs': [
        {
          'internalType': 'string',
          'name': '',
          'type': 'string'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'contractVersion',
      'outputs': [
        {
          'internalType': 'string',
          'name': '',
          'type': 'string'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'developer',
      'outputs': [
        {
          'internalType': 'address payable',
          'name': '',
          'type': 'address'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'getHubAddr',
      'outputs': [
        {
          'internalType': 'address',
          'name': '',
          'type': 'address'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'getMessageData',
      'outputs': [
        {
          'internalType': 'bytes',
          'name': '',
          'type': 'bytes'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'getRecipientBalance',
      'outputs': [
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'getSender',
      'outputs': [
        {
          'internalType': 'address',
          'name': '',
          'type': 'address'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'origSender',
          'type': 'address'
        },
        {
          'internalType': 'bytes',
          'name': 'msgData',
          'type': 'bytes'
        }
      ],
      'name': 'getSenderFromData',
      'outputs': [
        {
          'internalType': 'address',
          'name': '',
          'type': 'address'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'bytes',
          'name': 'context',
          'type': 'bytes'
        },
        {
          'internalType': 'bool',
          'name': 'success',
          'type': 'bool'
        },
        {
          'internalType': 'uint256',
          'name': 'actualCharge',
          'type': 'uint256'
        },
        {
          'internalType': 'bytes32',
          'name': 'preRetVal',
          'type': 'bytes32'
        }
      ],
      'name': 'postRelayedCall',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'bytes',
          'name': 'context',
          'type': 'bytes'
        }
      ],
      'name': 'preRelayedCall',
      'outputs': [
        {
          'internalType': 'bytes32',
          'name': '',
          'type': 'bytes32'
        }
      ],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address payable',
          'name': 'newDeveloper',
          'type': 'address'
        }
      ],
      'name': 'transferDeveloper',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'contract IRelayHub',
          'name': '_relayHub',
          'type': 'address'
        }
      ],
      'name': 'updateRelayHub',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [],
      'name': 'register',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [],
      'name': 'destroyContract',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'init',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [],
      'name': 'initiateFirstOwner',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [],
      'name': 'initiateOwners',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        },
        {
          'internalType': 'address',
          'name': 'who',
          'type': 'address'
        }
      ],
      'name': 'addAddressToOwnerList',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'rejectAddressFromOwnerList',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'approveOwner',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'getOwnerCounter',
      'outputs': [
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'getActiveOwnerCounter',
      'outputs': [
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'uint256',
          'name': '_id',
          'type': 'uint256'
        }
      ],
      'name': 'getOwner',
      'outputs': [
        {
          'internalType': 'uint256',
          'name': 'status',
          'type': 'uint256'
        },
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        },
        {
          'internalType': 'address',
          'name': 'proposer',
          'type': 'address'
        },
        {
          'internalType': 'address',
          'name': 'blocker',
          'type': 'address'
        },
        {
          'internalType': 'uint256',
          'name': 'regTime',
          'type': 'uint256'
        },
        {
          'internalType': 'address[]',
          'name': 'approvers',
          'type': 'address[]'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address',
          'name': '_old',
          'type': 'address'
        },
        {
          'internalType': 'address',
          'name': '_new',
          'type': 'address'
        }
      ],
      'name': 'changeOwner',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'isPerson',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'isTrustedPerson',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'isOwner',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'isMember',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'isReader',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'address',
          'name': 'addr',
          'type': 'address'
        }
      ],
      'name': 'setReader',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'isInitiatedFirstOwner',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [],
      'name': 'isInitiatedOwners',
      'outputs': [
        {
          'internalType': 'bool',
          'name': '',
          'type': 'bool'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': true,
      'inputs': [
        {
          'internalType': 'address',
          'name': '',
          'type': 'address'
        },
        {
          'internalType': 'address',
          'name': 'from',
          'type': 'address'
        },
        {
          'internalType': 'bytes',
          'name': '',
          'type': 'bytes'
        },
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        },
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        },
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        },
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        },
        {
          'internalType': 'bytes',
          'name': '',
          'type': 'bytes'
        },
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        }
      ],
      'name': 'acceptRelayedCall',
      'outputs': [
        {
          'internalType': 'uint256',
          'name': '',
          'type': 'uint256'
        },
        {
          'internalType': 'bytes',
          'name': '',
          'type': 'bytes'
        }
      ],
      'payable': false,
      'stateMutability': 'view',
      'type': 'function'
    },
    {
      'constant': false,
      'inputs': [
        {
          'internalType': 'uint256',
          'name': '_amount',
          'type': 'uint256'
        },
        {
          'internalType': 'address payable',
          'name': '_dest',
          'type': 'address'
        }
      ],
      'name': 'withdrawFromRelayHub',
      'outputs': [],
      'payable': false,
      'stateMutability': 'nonpayable',
      'type': 'function'
    }
  ];
